
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class ExtensionFieldDataTypeEditor extends Serenity.Select2Editor<any, any> {

        constructor(hidden: JQuery, opt: any) {
            super(hidden, opt);

            this.addOption("Code - varchar(50)", "Code - varchar(50)");
            this.addOption("Boolean - bit", "Boolean - bit");
            this.addOption("datetimeoffset", "datetimeoffset");
            this.addOption("int", "int");
            this.addOption("float", "float");
            this.addOption("smallint", "smallint");
            this.addOption("Text - nvarchar(max)", "Text - nvarchar(max)");
        }
    }

    @Serenity.Decorators.registerEditor()
    export class ExtensionFieldNameEditor extends Serenity.Select2Editor<any, ExtensionFieldRow> {

        constructor(hidden: JQuery, opt: any) {
            super(hidden, opt);
        }
    }
}